"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newComponents = require("../new-components");
var _pricing = require("../helpers/pricing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ExtrasOrdersRow = function ExtrasOrdersRow(_ref) {
  var _payment$feePayment;
  var item = _ref.item,
    hasFeePayment = _ref.hasFeePayment,
    payment = _ref.payment;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_newComponents.TableRow, null, /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-left"
  }, item.profile.firstName), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-left"
  }, item.quantity, " x ", item.productVariant.name), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-left"
  }, (0, _pricing.formatCurrency)(item.gross / 100, item.currency, item.currency)), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-left"
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Pill, {
    title: "paid",
    type: _newComponents.PILL_TYPES.SUCCESS_INVERT
  })), hasFeePayment && /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-left"
  }, (0, _pricing.formatCurrency)(((payment === null || payment === void 0 || (_payment$feePayment = payment.feePayment) === null || _payment$feePayment === void 0 ? void 0 : _payment$feePayment.amountRegistered) || 0) * -1 / 100, payment.currencyRegistered, payment.currencyPaid)), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-left d8-u-text-bold"
  }, payment && (0, _pricing.formatCurrency)((payment.amountPaid || 0) / 100, payment.currencyPaid, payment.currencyPaid) || "N/A")));
};
ExtrasOrdersRow.propTypes = {
  orders: _propTypes["default"].array,
  mainOrder: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = ExtrasOrdersRow;